<script setup>
const toast = useToastStore()
</script>

<template>
  <Teleport to="body">
    <div class="toast-wrap">
      <transition-group name="toast" tag="div">
        <div
          v-for="t in toast.items"
          :key="t.id"
          class="toast"
          :class="`toast-${t.type}`"
          @click="toast.dismiss(t.id)"
        >
          <span class="toast-msg">{{ t.message }}</span>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-wrap {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: .5rem;
  pointer-events: none;
}
.toast {
  pointer-events: auto;
  background: rgb(var(--c-surface));
  border: 1px solid rgb(var(--c-line));
  border-radius: 12px;
  padding: .75rem 1rem;
  box-shadow: 0 6px 24px rgba(0,0,0,.08);
  min-width: 240px;
  max-width: 360px;
  font-size: .85rem;
  cursor: pointer;
}
.toast-success { border-left: 4px solid #10b981; }
.toast-error   { border-left: 4px solid #ef4444; }
.toast-info    { border-left: 4px solid rgb(var(--c-brand)); }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateX(20px); }
.toast-enter-active, .toast-leave-active { transition: all .2s ease; }
</style>
